import { runHook } from "../hooks/hooks";
import { getDate } from "./date.utils";

export const log = (...msg) => {
    console.log(getDate(), ...msg);
    runHook("server:log", { msg });
};
